// Auto-generated normalizer for table: Cat_RedesSociales
export function catRedesSocialesNormalize(row) {
  return {
    idRedSocial: row.idRedSocial ?? row.IdRedSocial ?? row['IdRedSocial'] ?? 0,
    nombreRedSocial: row.nombreRedSocial ?? row.NombreRedSocial ?? row['NombreRedSocial'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
